// Lightweight GA4 wrapper — safe if gtag hasn't loaded yet.
const isBrowser = typeof window !== "undefined";

export const trackEvent = (name, params = {}) => {
  if (!isBrowser) return;
  const enriched = {
    page_path: window.location.pathname + window.location.search,
    page_location: window.location.href,
    ...params,
  };
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", name, enriched);
    }
    // Debug in local dev only
    if (window.location.hostname === "localhost") {
      // eslint-disable-next-line no-console
      console.debug("[analytics]", name, enriched);
    }
  } catch (_) {
    // never let analytics break the app
  }
};

export const trackPageview = () => {
  if (!isBrowser || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", "page_view", {
      page_path: window.location.pathname + window.location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  } catch (_) {}
};

// Delegated click tracker — inspects the closest <a> to categorise the click.
export const installClickTracker = () => {
  if (!isBrowser) return () => {};
  const handler = (e) => {
    const a = e.target && e.target.closest && e.target.closest("a,button");
    if (!a) return;
    const href = a.getAttribute("href") || "";
    const testid = a.getAttribute("data-testid") || "";
    const label = (a.getAttribute("aria-label") || a.textContent || "").trim().slice(0, 80);

    if (testid.startsWith("product-buy-") || testid === "product-detail-cta-buy") {
      trackEvent("buy_click", { link_text: label, testid, destination: href.includes("wa.me") ? "whatsapp" : "other" });
    } else if (href.includes("wa.me") || href.includes("api.whatsapp.com") || href.includes("whatsapp.com")) {
      trackEvent("whatsapp_click", { link_text: label, testid });
    } else if (href.startsWith("tel:")) {
      trackEvent("call_click", { phone: href.replace("tel:", ""), testid });
    } else if (href.startsWith("mailto:")) {
      trackEvent("email_click", { email: href.replace("mailto:", ""), testid });
    } else if (href.includes("/api/brochure")) {
      trackEvent("brochure_download", { testid });
    } else if (href.includes("play.google.com/store")) {
      trackEvent("app_install_intent", { store: "google_play", testid });
    }
  };
  document.addEventListener("click", handler, { capture: true });
  return () => document.removeEventListener("click", handler, { capture: true });
};
